module.exports = {
  "name": "福水智联开发",
  "short_name": "福水开发",
  "copyright": "福水智联技术有限公司",
  "display": "standalone",
  "start_url": "./?utm_source=homescreen",
  "theme_color": "#1e5588",
  "background_color": "#001529",
  "icons": [
    {
      "src": "/icons/icon-192x192.png",
      "sizes": "192x192"
    },
    {
      "src": "/icons/icon-128x128.png",
      "sizes": "128x128"
    },
    {
      "src": "/icons/icon-512x512.png",
      "sizes": "512x512"
    }
  ],
  "font_size_base": "16px",
  "api_url": "http://localhost:8801",
  "images": {
    "favicon": "/favicon.png",
    "login": {
      "background": "/login/login_bg.jpg",
      "title": "/login/login_title.png"
    }
  },
  "wea_sso_auth_url": "192.168.0.103:8801",
  "yzs_sso_auth_url": "http://119.3.215.188:8086/DSF/DSF_Transfer.aspx",
  "logon_expire_days": 365
}
